import React from "react";
import PropTypes from "prop-types";
import Button from "../../atoms/Button";
import { ReactComponent as FilterIcon } from "../../../images/filter-icon.svg";
import "./index.scss";

export default function FriendsFilterToggleButton({
    label,
    expanded = false,
    onClick = undefined,
    controlsId = undefined,
    active = false,
    iconOnly = false,
    className = "",
}) {
    const buttonClassName = [
        "friends-filter-toggle",
        expanded ? "friends-filter-toggle--expanded" : "",
        active ? "friends-filter-toggle--active" : "",
        iconOnly ? "friends-filter-toggle--icon-only" : "",
        className,
    ].filter(Boolean).join(" ");

    return (
        <Button
            type="button"
            variant="secondary"
            size="small"
            shape="pill"
            onClick={onClick}
            className={buttonClassName}
            aria-expanded={expanded}
            aria-controls={controlsId}
            aria-haspopup="dialog"
            aria-label={iconOnly ? label : undefined}
        >
            {iconOnly ? null : (
                <span className="friends-filter-toggle__label">{label}</span>
            )}
            <FilterIcon className="friends-filter-toggle__icon" aria-hidden="true" focusable="false" />
        </Button>
    );
}

FriendsFilterToggleButton.propTypes = {
    label: PropTypes.string.isRequired,
    expanded: PropTypes.bool,
    onClick: PropTypes.func,
    controlsId: PropTypes.string,
    active: PropTypes.bool,
    iconOnly: PropTypes.bool,
    className: PropTypes.string,
};
